import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, makeStyles } from '@material-ui/core';
import content from '../content';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: '10px'
  },
  tabsRoot: {
    width: '100%'
  },
  indicator: {
    backgroundColor: theme.palette.primary.light,
    border: `1px solid ${theme.palette.primary.main}`,
    zIndex: '-1',
    height: '100%',
    borderRadius: '4px'
  }
}));

const SearchTabs = ({ keys, selectedTab, onTabChange }) => {
  const classes = useStyles();
  const renderTabs = () => keys.map(key => <Tab key={key} label={content[key]} disableRipple />);

  return (
    <Tabs
      className={classes.root}
      classes={{ root: classes.tabsRoot, indicator: classes.indicator }}
      value={selectedTab}
      variant="fullWidth"
      onChange={onTabChange}
      textColor="primary"
    >
      {renderTabs()}
    </Tabs>
  );
};

SearchTabs.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired
};

export default SearchTabs;
